import { faGithub } from "@fortawesome/free-brands-svg-icons";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import "./Project.css";

const Project = (props) => {
    const { img, name, desc, tech, site, client } = props.project;
    return (
        <div className="col-md-4 project-container">
            <div className="card project-card">
                <img src={img} class="card-img-top" alt="..." />
                <div className="card-body">
                    <h5 className="card-title">{name}</h5>
                    <p className="card-text">{desc}</p>
                    <div className="technology">
                        <span style={{ fontSize: "14px" }}>{tech}</span>
                    </div>
                    <div className="mt-3">
                        <a target="_blank" rel="noreferrer" href={site}>
                            <button className="button work-button">
                                <FontAwesomeIcon icon={faGlobe} /> Live
                            </button>
                        </a>

                        <a target="_blank" rel="noreferrer" href={client}>
                            <button className="button work-button">
                                <FontAwesomeIcon icon={faGithub} /> Code
                            </button>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Project;
